import _eol from "eol";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const convertToHtml = _convertToHtml;
const convertToPlainText = _convertToPlainText;
const eol = _eol;
const timecodeRegex = /^\d{2}:\d{2}:\d{2}:\d{2}$/;
const maxDurationSec = 12;
function fixText(input) {
  return input.replace(/\u0011[Pp]/g, "\n").replace(/\u00117/g, "\u266A").replace(/\u0012[\x20-\x7e]/g, "").replace(/\u0014[\x20-\x7e]/g, "").trim();
}
function getTimecode(sec, options) {
  return tcLib.secToTc(sec, options.frameRate, options.dropFrame);
}
function applyFirstEventStartTimes(events, options) {
  if (events.length === 0) {
    return events;
  }
  let offsetTc = events[0].rawFlcTc;
  let offsetSec = tcLib.tcToSec(offsetTc, options.frameRate, options.dropFrame);
  events.forEach(event => {
    if (event.start - offsetSec >= 0) {
      event.start -= offsetSec;
      if (event.end - offsetSec >= 0) {
        event.end -= offsetSec;
      } else {
        let originalEnd = event.end;
        let highestFrame = options.frameRate === 29.97 ? 29 : options.frameRate - 1;
        event.end = tcLib.tcToSec("23:59:59:" + highestFrame, options.frameRate, options.dropFrame);
        event.end -= offsetSec;
        event.end += originalEnd;
      }
    } else {
      let originalStart = event.start;
      let originalEnd = event.end;
      let highestFrame = options.frameRate === 29.97 ? 29 : options.frameRate - 1;
      event.start = tcLib.tcToSec("23:59:59:" + highestFrame, options.frameRate, options.dropFrame);
      event.end = event.start;
      event.start -= offsetSec;
      event.end -= offsetSec;
      event.start += originalStart;
      event.end += originalEnd;
    }
    if (isNaN(event.end)) {
      event.end = event.start + 2;
    }
  });
  return events;
}
function encodeText(text) {
  let plainText = convertToPlainText(text).trim();
  if (plainText.length === 0) {
    return "\u0014\u002c";
  }
  return "\u0014\u0025\u0014\u002d" + plainText.replace(/\r?\n/g, "\u0011P").replace(/\u266A/g, "\u00117").replace(/'/g, "'\u0012\u0029");
}
export default {
  decode: function (input, options) {
    let events = [];
    let ccEvent = new Event({
      style: "Roll-Up 2"
    });
    let expectingText = false;
    eol.split(input).forEach(line => {
      if (timecodeRegex.test(line)) {
        ccEvent = new Event({
          style: "Roll-Up 2"
        });
        ccEvent.rawFlcTc = line;
        ccEvent.start = tcLib.tcToSec(line, options.frameRate, options.dropFrame);
        if (events.length > 0) {
          events[events.length - 1].end = ccEvent.start;
        }
        expectingText = true;
        return;
      }
      if ((expectingText || ccEvent.text) && line.length > 0) {
        ccEvent.text = (ccEvent.text + "\n" + line.trim()).trim();
        if (!events.includes(ccEvent)) {
          events.push(ccEvent);
        }
        expectingText = false;
      }
    });
    events = applyFirstEventStartTimes(events, options);
    events.forEach((event, index) => {
      event.text = fixText(event.text);
      event.text = convertToHtml(event.text);
    });
    return events;
  },
  encode: function (eventGroup, options) {
    let output = "";
    eventGroup.events.forEach((event, index) => {
      output += getTimecode(event.start, options) + "\r\n";
      output += encodeText(event.text) + "\r\n";
      let next = eventGroup.events[index + 1];
      if (!next || next.start > event.start + maxDurationSec) {
        output += getTimecode(event.end, options) + "\r\n";
        output += "\u0014\u002c\r\n";
      }
    });
    return output.trim();
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input).replace(/^\uFEFF/, "").trim();
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};